export const QA_NAME_GRETA_AI_CHAT_PROJECT_MENU = 'gretaAIChatProjectMenu'

export const QA_NAME_GRETA_AI_CHAT_PROJECT_MENU_RENAME =
  'gretaAIChatProjectMenuRename'

export const QA_NAME_GRETA_AI_CHAT_PROJECT_MENU_DELETE =
  'gretaAIChatProjectMenuDelete'
